class CustomDialog extends HTMLElement {
    constructor() {
        super();
        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.handleDialogClose = this.handleDialogClose.bind(this);
        this.handleCloseButtonClick = this.handleCloseButtonClick.bind(this);
    }

    connectedCallback() {
        this.dialog = this.querySelector('dialog');
        const dataTargetValue = this.getAttribute('data-target');

        if (!this.dialog) {
            console.error(`Dialog not found for ${this.tagName}`);
            return;
        }

        if (dataTargetValue) {
            this.buttons = document.querySelectorAll(`button[data-target="${dataTargetValue}"]`);
            this.buttons.forEach(button => {
                button.addEventListener('click', this.handleButtonClick);
            });
        }

        this.closeButtons = this.querySelectorAll(`button[data-dialog="close"]`);

        this.closeButtons.forEach(button => {
            button.addEventListener('click', this.handleCloseButtonClick);
        });

        this.dialog.addEventListener('click', this.handleDialogClose);

        if (this.hasAttribute('auto-open')) {
            setTimeout(() => {
                this.openDialog();
            }, 100);
        }
    }

    disconnectedCallback() {
        this.buttons?.forEach(button => {
            button.removeEventListener('click', this.handleButtonClick);
        });

        this.closeButtons?.forEach(button => {
            button.removeEventListener('click', this.handleCloseButtonClick);
        });

        if (this.dialog) {
            this.dialog.removeEventListener('click', this.handleDialogClose);
        }
    }

    handleButtonClick() {
        if (!this.dialog) return;

        this.openDialog();
    }

    handleCloseButtonClick() {
        this.closeDialog();
    }

    handleDialogClose(event) {
        if (!this.dialog) return;

        const rect = this.dialog.getBoundingClientRect();
        const isOutsideDialog = !(
            event.clientX >= rect.left &&
            event.clientX <= rect.right &&
            event.clientY >= rect.top &&
            event.clientY <= rect.bottom
        );

        if (isOutsideDialog) {
            this.closeDialog();
        }
    }

    openDialog() {
        if (!this.dialog) return;

        const dialogContent = this.dialog.querySelector('.dialog') || this.dialog;
        dialogContent.classList.add('fade-in');
        this.dialog.showModal();

        this.dispatchEvent(new CustomEvent('dialog-opened', {
            bubbles: true,
            detail: {dialog: this.dialog}
        }));
    }

    closeDialog() {
        if (!this.dialog) return;

        const dialogContent = this.dialog.querySelector('.dialog') || this.dialog;
        dialogContent.classList.remove('fade-in');

        setTimeout(() => {
            this.dialog.close();
        }, 300);

        this.dispatchEvent(new CustomEvent('dialog-closed', {
            bubbles: true,
            detail: {dialog: this.dialog}
        }));
    }

    open() {
        this.openDialog();
    }

    close() {
        this.closeDialog();
    }
}

customElements.define('custom-dialog', CustomDialog);

class CountryDialog extends CustomDialog {
    constructor() {
        super();
    }

    connectedCallback() {
        super.connectedCallback();
        if (this.hasAttribute('auto-open')) {
            setTimeout(() => {
                this.openDialog();
            }, 200);
        }
    }

    openDialog() {
        super.openDialog();
    }
}
customElements.define('country-dialog', CountryDialog);

class NewsletterDialog extends CustomDialog {
  
  COOKIE_NAME = 'newsletter_is_popup_seen';

  constructor() { 
    super(); 

    this.utils = new Utils();
    this.form = this.querySelector('form');
  }

  connectedCallback() {
    super.connectedCallback();
    
    this.setListeners();
    this.checkCookie();
  }

  checkCookie() {
    const isSubscribed = this.utils.getCookie(this.COOKIE_NAME);
    setTimeout(() => {
      !isSubscribed && super.openDialog();
    }, 500);
  }

  closeDialog() {
    super.closeDialog();
    this.utils.setCookie(this.COOKIE_NAME, 'true', 365);
  }

  setListeners() {
    this.form?.addEventListener('submit', (event) => {
      this.utils.setCookie(this.COOKIE_NAME, 'true', 365);
    });
  }

}
customElements.define('newsletter-dialog', NewsletterDialog);